import {Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar bg-white/80 backdrop-blur-md border-b border-slate-200/60 sticky top-0 z-50">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-rose-600 tracking-tight hover:opacity-80 transition-opacity">
            The Dojo Blog
        </Link>
        <div className="links flex items-center gap-6">
            <Link to='/' className="text-slate-600 hover:text-primary transition-colors font-medium text-sm md:text-base">
              Home
            </Link>
            <Link to="/create" className="bg-gradient-to-r from-primary to-rose-600 text-white px-5 py-2.5 rounded-full hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 shadow-md font-medium text-sm md:text-base">
              New Blog
            </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navbar;
